import Table from "Shared/components/DataTable/Table"
import restClient from "Shared/hooks/restClient"
import PinnedBookmarks from "Shared/components/PinnedBookmarks/PinnedBookmarks"

const CampaignsDatatable = ({type = null}) => {
  const handleTableClick = (e) => {
    const button = e.target.closest('button')
    if (button && button.classList.contains('toggle-bookmark')) {
      restClient
        .post('/api/user_bookmarks/toggle', { entity_type: 'Campaign', entity_id: button.dataset.id })
        .then(() => {
          window.dispatchEvent(new CustomEvent('bookmarks-changed', { detail: { entityType: 'Campaign' } }))
        })
    }
    if (button && button.classList.contains('restore-campaign')) {
      const campaignId = button.dataset.campaignId

      if (window.confirm('Are you sure you want to restore this campaign?')) {
        restClient.post(`/api/campaigns/${campaignId}/restore`).then(() => {
          window.location.href = '/admin/campaigns'
        })
      }
    }
  }

  const tableProps = {
    table: 'campaigns',
    scope: { type },
    language: { emptyTable: 'There are no matching campaigns', searchPlaceholder: 'Search by name' },
    onClick: handleTableClick,
  }

  const reloadTable = () => {
    window.$('table').DataTable().ajax.reload(null, false)
  }

  useEffect(() => {
    const handler = (e) => {
      if (e.detail?.entityType === 'Campaign') reloadTable()
    }
    window.addEventListener('bookmarks-changed', handler)
    return () => window.removeEventListener('bookmarks-changed', handler)
  }, [])

  return (
    <>
      <PinnedBookmarks entityType="Campaign" />

      <div className="box">
        <Table {...tableProps} />
      </div>
    </>
  )
}

export default CampaignsDatatable
